import { useContext, useMemo } from 'react';
import { PageContext } from '../../page/context';
import { ModalContext } from './index';

export const ModalProvider = ({ children }) => {
  const pageContext = useContext(PageContext);

  const state = useMemo(
    () => ({
      rootPageContext: pageContext
    }),
    [pageContext]
  );

  return (
    <ModalContext.Provider value={state}>{children}</ModalContext.Provider>
  );
};
